'use strict';

var at = require('../../utils/environment');


var SMALLEST_MEDIUM_WIDTH = 620;
var SMALLEST_LARGE_WIDTH = 1000;

module.exports.choose = function (content) {
    if (content.image === undefined) return null;

    var sizes = content.image.sizes;

    if (at.client && sizes) {
        if (window.innerWidth < SMALLEST_MEDIUM_WIDTH) return sizes.S.url;
        else if (window.innerWidth < SMALLEST_LARGE_WIDTH) return sizes.M.url;
        else return sizes.S.url;
    }
    else return content.image.url;
};